import React, { useEffect, useRef, useState, } from 'react';
import { langCheck, debounce } from "../../pub/js/utils";
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import platform from "Pub/js/platform";
const { base } = platform;
import { setStore, getStore } from "Pub/js/storageUtils";
const { NCTooltip } = base;


const CollectTooltip = (props) => {
    const { itemData, setNewContentData, contentData, isAllapps = false, isRecentVisit = false, getMyappData } = props;
    const { is_collect, appcode, menuitemid, menuitemcode, is_cloud_app } = itemData;
    const collectVal = `${menuitemcode}${appcode}`; // 启用不同的菜单，menuitemid不同，使用菜单编码和应用编码匹配
    // const [isCollect, setIsCollect] = useState(is_collect);
    // const prevCountRef = useRef();
    // useEffect(() => {
    //     prevCountRef.current = collectObj.is_collect;
    // })
    // useEffect(() => {
    //     if (!isAllapps) {
    //         setIsCollect({ is_collect })
    //     }
    // }, [is_collect, prevCountRef.current])

    // 收藏 取消收藏 接口
    const _appCollect = ({ reqData, info, msg }) => {
        Ajax({
            url: `/nccloud/platform/appregister/appcollect.do`,
            info: info,
            data: reqData,
            success: res => {
                const { success, data } = res.data;
                if (success) {
                    if (parseInt(data.success) <= 60) {
                        // 更新缓存内的数据
                        const { menuitemcode, is_collect } = reqData;
                        const cacheKey = `moduleMenus${menuitemcode.substr(0, 4)}`;
                        const cacheMenuModules = getStore(cacheKey);
                        if (cacheMenuModules) {
                            const menu = cacheMenuModules.find(item => menuitemcode.startsWith(item.code));
                            if (menu && menu.children) {
                                for (let i = 0; i < menu.children.length; i++) {
                                    if (menu.children[i].code === menuitemcode) {
                                        menu.children[i].is_collect = is_collect;
                                        break;
                                    }
                                }
                            }
                            setStore(cacheKey, cacheMenuModules);
                        }
                        setCollectType();
                        isRecentVisit && is_collect && getMyappData && getMyappData()
                        Notice({
                            status: "success",
                            msg
                        });
                    } else {
                        Notice({
                            status: "warning",
                            msg: data.error
                        });
                    }

                }
            }
        });
    }
    // 收藏图标切换
    const setCollectType = () => {
        const newContentData = JSON.parse(JSON.stringify(contentData));
        newContentData.forEach(element => {
            if (isAllapps) {
                element.children.map(item => {
                    if (`${item.code || item.menuitemcode}${item.appcode}` === collectVal) {
                        item.is_collect = !item.is_collect
                    }
                    return item;
                })
            } else {
                if (`${element.menuitemcode}${element.appcode}` === collectVal) {
                    element.is_collect = !element.is_collect
                }
                return element;
            }
        });
        setNewContentData(newContentData);
    }
    const handleCollectApp = debounce(() => {
        let info = {
            name: langCheck('0000PUB-000101'), /* 国际化处理： 所有应用*/
            action: langCheck('0000PUB-000403') /* 国际化处理： 菜单收藏操作*/
        };
        let reqData = {
            appcode,        //----应用编码
            menuitemcode,  // ----菜单编码
            menuitemid,  //---菜单主键
            is_cloud_app, //
            "is_collect": !is_collect,  //   ----收藏为true，取消收藏为false
        };
        const msg = !is_collect ? langCheck('0000PUB-000407') : langCheck('0000PUB-000408'); // 多语-收藏成功-取消收藏成功
        _appCollect({ reqData, info, msg });
    }, 300);



    const classNameType = is_collect ? 'iconfont icon-shoucangdianliang' : 'iconfont icon-shoucang1 icon-collect';
    const style = is_collect ? { color: '#F09E44', fontSize: '16px', visibility: 'visible' } : {};
    const showMsg = is_collect ? langCheck('0000PUB-000432') : langCheck('0000PUB-000386');  //多语 - 取消收藏  收藏
    return (
        <React.Fragment>
            <NCTooltip
                className="app-tooltip"
                placement='top'
                overlay={showMsg}
                /** 收藏 */
                trigger='hover'
                delayShow={500}
                delay={1}
                getPopupContainer={() => document.body}
            >
                <i
                    className={classNameType}
                    style={style}
                    onClick={(e) => { e.stopPropagation(); handleCollectApp() }}
                />

            </NCTooltip>
        </React.Fragment>
    )
}
export default CollectTooltip;